module.exports = __webpack_public_path__ + "assets/images/agent_b_7e3a7b9e715bca136195fbb701be4bab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feedback/agent_b.png
// module id = 76
// module chunks = 0